import React from 'react'
import { Outlet, useParams } from 'react-router-dom'

import { useTranslation } from '@disco/i18n/use-translation'
import { getClientLibrary } from '@disco/state-management/selectors/client-libraries'

import type { ClientLibrary } from 'types/client-library'
import type { State } from 'types/redux'

import DocumentHeadTags from 'components/document-head-tags'
import LibraryPlaylistsManager from 'components/libraries/library-playlists-manager'
import PageContainer from 'components/ui/page-container'

import { useSelector } from 'hooks/use-redux'

const LibrariesLibraryPlaylists = (): React.ReactNode => {
  const params = useParams<{ libraryId: string }>()
  const { t } = useTranslation('catalogs-management')
  const libraryId: number = parseInt(params.libraryId!, 10)
  const library: ClientLibrary = useSelector((state: State) =>
    getClientLibrary(state, libraryId),
  )

  return (
    <PageContainer>
      <PageContainer.Section
        title={t('catalogs-management:playlists', 'Playlists')}
        description={t(
          'catalogs-management:playlistsDescription',
          'Here you can choose which playlists should appear on the Catalog and be featured on the home page. You can also add cover art for your playlists.',
        )}
      >
        {library && !library['loading'] && (
          <DocumentHeadTags
            title={t(
              'catalogs-management:catalogPlaylistsDisco',
              '{{name}} | Playlists | DISCO',
              { name: library['name'] },
            )}
          />
        )}
        <LibraryPlaylistsManager
          libraryId={libraryId}
          basePath={`/catalogs/${libraryId}/playlists`}
        />
        <Outlet />
      </PageContainer.Section>
    </PageContainer>
  )
}

export default LibrariesLibraryPlaylists
